module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAYBAMAAADuTAsBAAAAHlBMVEVHcEwsLCwrKysqKionJycoKCgrKysqKionJycpKSmYgMBWAAAACnRSTlMAXFMsCSJIPRkyibje4gAAAI5JREFUCNdNjjsOwjAQREciCaKcRElEh/n0UNFGSNwj3ABQ6B1xAbgxO2sXTGG99cx+AFyf29cAUxlIHkQnSkf7cmALXBLVg8zdO8i+qTRjRGADLMiNUettojWwElkuYlbuS/ZnG/NR6YqoEnT/26xFGo3mHAOWgl73Fbp0L3I7Otn6BkkP3jNVXQYUk94f/GQVYIWykSsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/address.png
// module id = R2WG
// module chunks = 1